module.exports = __webpack_public_path__ + "img/ipad-horizontal.7cea3016.png";